import './styles/tailwind.scss'
import './js/main.js'
